"use client"

import type { TransactionIdentifier } from "@opensea/graphql"
import {
  Separator,
  SideSheetBody,
  SideSheetHeader,
  SideSheetHeaderTitle,
  UnstyledButton,
} from "@opensea/ui-kit"
import { ExpandMore } from "@opensea/ui-kit/icons"
import { useTranslations } from "use-intl"
import { SmartContractWalletWarningModal } from "../../../components/SmartContractWalletWarningModal"
import { useSmartContractWalletWarningModal } from "../../../components/SmartContractWalletWarningModal/use-smart-contract-warning-modal"
import { FlowActions } from "../../../stores/flowStore"
import type { Item } from "../../../types"
import { MoonPayCheckoutWidget } from "./MoonPayCheckoutWidget"

type FiatCheckoutFlowContentProps = {
  item: Item
  listingId: string
  onBack: (() => void) | undefined
  onTransactionCreated?: (transactionIdentifier: TransactionIdentifier) => void
}

export const FiatCheckoutFlowContent = ({
  item,
  listingId,
  onBack,
  onTransactionCreated,
}: FiatCheckoutFlowContentProps) => {
  const t = useTranslations("wallet.FiatCheckoutFlowContent")

  const {
    smartContractWalletWarningModalOpen,
    setSmartContractWalletWarningModalOpen,
  } = useSmartContractWalletWarningModal({
    destinationChain: item.chain.identifier,
  })

  return (
    <>
      <SideSheetHeader className="gap-4">
        {onBack && (
          <UnstyledButton onClick={onBack}>
            <ExpandMore className="rotate-90" size={24} title="Back" />
          </UnstyledButton>
        )}
        <SideSheetHeaderTitle>{t("title")}</SideSheetHeaderTitle>
      </SideSheetHeader>
      <Separator />
      <SideSheetBody className="flex grow flex-col items-center justify-center py-6">
        <MoonPayCheckoutWidget
          item={item}
          listingId={listingId}
          onTransactionCreated={onTransactionCreated}
        />
      </SideSheetBody>
      <SmartContractWalletWarningModal
        onCancel={onBack ?? FlowActions.endFlow}
        onContinue={() => setSmartContractWalletWarningModalOpen(false)}
        open={smartContractWalletWarningModalOpen}
      />
    </>
  )
}
